import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { MODAL_KEYS, ORIGIN } from 'app-constants'
import { PasswordLogo } from 'components'
import { passwordService } from 'services'
import { fetchCustomer } from 'slices/customer'
import { setModal } from 'slices/modal'
import { PasswordForm, TokenValidation } from './components'
import './style.scss'

export function PasswordResetRequired() {
  const [isTokenValidation, setIsTokenValidation] = useState(false)
  const [password, setPassword] = useState(null)
  const { document } = useSelector(({ customer }) => customer.info)
  const { resetPassword } = passwordService()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchCustomer())
  }, [dispatch])

  async function handleTokenValidated(token) {
    try {
      await resetPassword({
        password,
        brand: ORIGIN,
        document,
        token,
      })
      dispatch(setModal({ key: MODAL_KEYS.REQUIRED_PASSWORD_UPDATE, data: { success: true } }))
    } catch (error) {
      console.error(error)
      dispatch(setModal({ key: MODAL_KEYS.REQUIRED_PASSWORD_UPDATE, data: { success: false } }))
    }
  }

  function handlePasswordConfirmed(newPassword) {
    setPassword(newPassword)
    setIsTokenValidation(true)
  }

  function renderContent() {
    if (isTokenValidation) return <TokenValidation onContinue={handleTokenValidated} />

    return <PasswordForm onContinue={handlePasswordConfirmed} />
  }

  return (
    <div className='password-reset-required-page'>
      <PasswordLogo />
      <div className='content-container'>{renderContent()}</div>
    </div>
  )
}
